"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const react_1 = __importStar(require("react"));
const react_phone_number_input_1 = require("react-phone-number-input");
const label_1 = __importDefault(require("../../label"));
const use_form_1 = __importStar(require("../../../form/use-form"));
const read_only_1 = __importDefault(require("../../read-only"));
const phone_field_1 = require("./phone-field");
const phone_entension_1 = require("./phone-entension");
const phone_type_1 = require("./phone-type");
const utils_1 = require("../../../utils");
const PHONE_FIELDS = {
    extension: phone_entension_1.PhoneExtension,
    phone: phone_field_1.Phone,
    type: phone_type_1.PhoneType
};
const InlineRow = styled_1.default.div `
  display: flex;
  flex-direction: row;
`;
/**
 * Input that handles formatting and validation of phone numbers
 */
const PhoneInput = ({ path, showLabel = true }) => {
    const [{ AddOn, config }] = (0, use_form_1.default)(path);
    // field configs
    const { extension: { path: extPath = '' } = {}, phone: { path: phonePath }, type: { path: typePath = '' } = {} } = config.subFields;
    const [phoneState] = (0, use_form_1.default)(phonePath);
    const [extState] = (0, use_form_1.default)(extPath);
    const [typeState] = (0, use_form_1.default)(typePath);
    const { context: { isRequiredMarker, isNotRequiredMarker } } = (0, react_1.useContext)(use_form_1.FormContext);
    const getReadOnlyText = () => {
        const extensionString = extState.value ? ` x${extState.value}` : '';
        const typeString = typeState.value ? ` - ${typeState.value}` : '';
        const formattedValue = (0, react_phone_number_input_1.formatPhoneNumber)(phoneState.value);
        const valueToDisplay = formattedValue || phoneState.value;
        return `${valueToDisplay}${extensionString}${typeString}`;
    };
    const { isReadOnly, isRequired, isVisible, label = config.label } = phoneState.config;
    if (isVisible === false)
        return react_1.default.createElement(react_1.default.Fragment, null);
    if (isReadOnly) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(label_1.default, { visuallyHidden: showLabel === false }, label),
            react_1.default.createElement(read_only_1.default, { msg: getReadOnlyText() })));
    }
    // subFields that are known to this Phone Input from PHONE_FIELDS
    const validPhoneInputSubFields = Object.keys(config.subFields).reduce((fields, key) => {
        if (PHONE_FIELDS[key] != null) {
            fields.push(Object.assign({ configKey: key }, config.subFields[key]));
        }
        return fields;
    }, []);
    const phoneFields = (0, utils_1.orderFields)(validPhoneInputSubFields).map(({ configKey }) => {
        const Component = PHONE_FIELDS[configKey];
        const { path } = config.subFields[configKey];
        return (react_1.default.createElement(Component, { key: `phone-field-${path}`, path: path, inputPath: config.path }));
    });
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(label_1.default, { visuallyHidden: showLabel === false, isRequired: isRequired, isRequiredMarker: isRequiredMarker, isNotRequiredMarker: isNotRequiredMarker }, label),
        react_1.default.createElement(InlineRow, null, phoneFields),
        react_1.default.createElement(AddOn, null)));
};
exports.default = PhoneInput;
exports.defaultConfig = {
    extension: { placeholder: 'Ext.', autoComplete: 'tel-extension' },
    phone: { placeholder: '(___) ___-____', autoComplete: 'tel' },
    type: { placeholder: 'Select Type' }
};
//# sourceMappingURL=index.js.map